// extracted by mini-css-extract-plugin
export var container = "_i2-0";
export var content = "_i2-3";
export var customerTitle = "_i2-4";
export var empty = "_i2-5";
export var gray = "_i2-6";
export var header = "_i2-7";
export var info = "_i2-8";
export var loading = "_i2-2";
export var loadingCard = "_i2-9";
export var oneLine = "_i2-a";
export var personName = "_i2-e";
export var pillContainer = "_i2-b";
export var selected = "_i2-1";
export var text = "_i2-c";
export var twoLines = "_i2-d";
export var unread = "_i2-f";
export var unreadIndicator = "_i2-g";